import { render, staticRenderFns } from "./InvoicesIssued.vue?vue&type=template&id=f152cae0&scoped=true"
import script from "./InvoicesIssued.vue?vue&type=script&lang=js"
export * from "./InvoicesIssued.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f152cae0",
  null
  
)

export default component.exports